module.exports = __webpack_public_path__ + "img/source_icon.29354ac3.svg";